export default "__VITE_ASSET__DlrPmVqh__"